<template>
    <layouts-header></layouts-header>

    <breadcrumb :title="title" :text="text" :text1="text1" />

    <!-- Page Content -->
    <div class="content">
        <div class="container">

            <!-- Sort By -->
            <div class="row">
                <div class="col-lg-12">
                    <div class="sortby-section">
                        <div class="sorting-info">
                            <div class="row d-flex align-items-center">
                                <div class="col-xl-4 col-lg-3 col-sm-12 col-12">
                                    <div class="count-search">
                                        <p><span>150</span> coaches are listed</p>
                                    </div>
                                </div>
                                <div class="col-xl-8 col-lg-9 col-sm-12 col-12">
                                    <div class="sortby-filter-group">
                                        <div class="grid-listview">
                                            <ul class="nav">
                                                <li>
                                                    <span>View as</span>
                                                </li>
                                                <li>
                                                    <router-link to="/coaches/coaches-grid">
                                                        <img src="@/assets/img/icons/sort-01.svg" alt="Icon">
                                                    </router-link>
                                                </li>
                                                <li>
                                                    <router-link to="/coaches/coaches-list" class="active">
                                                        <img src="@/assets/img/icons/sort-02.svg" alt="Icon">
                                                    </router-link>
                                                </li>
                                                <li>
                                                    <router-link to="/coaches/coaches-map">
                                                        <img src="@/assets/img/icons/sort-03.svg" alt="Icon">
                                                    </router-link>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="sortbyset">
                                            <span class="sortbytitle">Sort By</span>
                                            <div class="sorting-select">
                                                <vue-select :options="Sort" id="sorttwo" placeholder="Relevance" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <!-- Sort By -->

            <div class="row">

                <!-- Featured Item -->
                <div class="col-lg-12" v-for="item in CoachesList" :key="item.id">
                    <div class="featured-venues-item">
                        <div class="listing-item listing-item-grid coach-listview">
                            <div class="listing-img">
                                <router-link to="/coaches/coach-detail">
                                    <img :src="require(`@/assets/img/featured/${item.Image}`)" alt="Venue">
                                </router-link>
                                <div class="fav-item-venues">
                                    <span class="tag tag-blue">{{ item.Badge }}</span>
                                    <div class="list-reviews coche-star">
                                        <a href="javascript:void(0)" class="fav-icon" @click="toggleSelected(item)"
                                            :class="{ selected: item.isSelected }">
                                            <i class="feather-heart"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="listing-content">
                                <div class="list-reviews near-review near-review-list">
                                    <div class="d-flex align-items-center">
                                        <span class="rating-bg">4.2</span><span>{{ item.Reviews }}</span>
                                    </div>
                                    <span class="mile-away"><span>From</span> {{ item.Price }} <span>/hr</span></span>
                                </div>
                                <h3 class="listing-title">
                                    <router-link to="/coaches/coach-detail">{{ item.Name }}</router-link>
                                </h3>
                                <ul class="mb-2">
                                    <li>
                                        <span>
                                            <i class="feather-map-pin me-2"></i>{{ item.Location }}
                                        </span>
                                    </li>
                                </ul>
                                <div class="listing-details-group">
                                    <p>{{ item.Content }}</p>
                                </div>
                                <div class="avalbity-review avalbity-review-list">
                                    <ul>
                                        <li>
                                            <div class="avalibity-date">
                                                <span><i class="feather-calendar"></i></span>
                                                <div class="avalibity-datecontent">
                                                    <h6>Next Availabilty</h6>
                                                    <h5>{{ item.Date }}</h5>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    <ul class="profile-coache-list">
                                        <li>
                                            <router-link to="/coaches/coach-detail" class="btn btn-primary w-100"><i
                                                    class="feather-eye me-2"></i> View Profile</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/coaches/coach-detail" class="btn btn-secondary w-100"><i
                                                    class="feather-calendar me-2"></i> Book Now</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /Featured Item -->

                <div class="col-12 text-center mt-3">
                    <a href="javascript:;" class="btn btn-load">Load More Coaches <img
                            src="@/assets/img/icons/u_plus-square.svg" class="ms-2" alt="Icon"></a>
                </div>
            </div>
        </div>

    </div>
    <!-- /Page Content -->

    <layout-footer></layout-footer>
</template>

<script>
import CoachesList from '@/assets/json/coaches-list.json'
export default {
    data() {
        return {
            CoachesList: CoachesList,
            title: 'Coaches List Without Sidebar',
            text: 'Home',
            text1: 'Coaches List',
            isSelected: false,
            Sort: ["Relevance", "Price"]
        }
    },
    methods: {
        toggleSelected(item) {
            item.isSelected = !item.isSelected;
        },
    },
}
</script>